import { fromJS } from 'immutable';

import {
  LOAD_PICDATA,
  LOAD_PICDATA_SUCCESS,
  LOAD_PICDATA_ERROR
} from './constants';
import { ILoadPicdataAction, IPicdataLoaded, IPicdataLoadingError } from 'containers/HomePage/actions';

const initialState = fromJS({
  loading: false,
  error: false,
  hitokoto: undefined
});

type IAction = ILoadPicdataAction | IPicdataLoaded | IPicdataLoadingError;

export default function homeReducer(state = initialState, action: IAction) {
  switch (action.type) {
    case LOAD_PICDATA:
      return state
        .set('loading', true)
        .set('error', false)
        .set('picdata', undefined);
    case LOAD_PICDATA_SUCCESS:
      return state
        .set('loading', false)
        .set('picdata', action.picdata);
    case LOAD_PICDATA_ERROR:
      return state
        .set('error', action.error)
        .set('loading', false);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/containers/HomePage/reducer.ts